"use strict";
var urllite = require("urllite/lib/core"), once = require("../lib/utils/once");
var warningShown = false;
var supportsXHR = once(function() {
  return typeof window !== "undefined" && window !== null && window.XMLHttpRequest && "withCredentials" in new window.XMLHttpRequest();
});
module.exports = {
  createXHR: function(req) {
    var a, b, k;
    if (typeof window === "undefined" || window === null) {
      return;
    }
    a = urllite(req.url);
    b = urllite(window.location.href);
    if (!a.host) {
      return;
    }
    if (a.protocol === b.protocol && a.host === b.host && a.port === b.port) {
      return;
    }
    if (!warningShown && req.headers) {
      for (k in req.headers) {
        if (req.headers.hasOwnProperty(k)) {
          warningShown = true;
          if (window && window.console && window.console.warn) {
            window.console.warn("Request headers are ignored in old IE when using the oldiexdomain plugin.");
          }
          break;
        }
      }
    }
    if (window.XDomainRequest && !supportsXHR()) {
      var xdr = new window.XDomainRequest();
      xdr.setRequestHeader = function() {
      };
      return xdr;
    }
  }
};
